import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// @ts-ignore
import VueTheMask from 'vue-the-mask';
import "./plugins/vuetify-money";
// import VueMask from "di-vue-mask";

import VueCurrencyFilter from "vue-currency-filter";
import {
  ValidationProvider,
  extend,
  localize,
  setInteractionMode,
  ValidationObserver,
} from "vee-validate";
import "./assets/css/styles.scss";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { required, email, max, max_value, min, min_value, confirmed, required_if } from "vee-validate/dist/rules";
import ptBR from "./api/commons/pt_BR.json";
// @ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';
import { CPFValidator, CNPJValidator } from "@/validators";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDJ0Uy0n2K1IiKkHKmH6uzewTqWZm6EapI',
    libraries: 'places', 
  },
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Vue.use(VueMask);
Vue.use(VueTheMask);

const moment = require("moment");
require("moment/locale/pt-br");

Vue.use(require("vue-moment"), {
  moment,
});

//Vue.use(VueCurrencyFilter);
// or with custom config
Vue.use(VueCurrencyFilter, {
  symbol: "R$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

localize({
  ptBR,
});
localize("ptBR");
setInteractionMode("lazy");

// Validações de formulário Vee-Validate
extend("required", required);
extend("min", min);
extend("max", max);
extend("min_value", min_value);
extend("max_value", max_value);
extend("email", email);
extend("confirmed", confirmed);
extend("required_if", required_if);
extend("required_if_sem_field", required_if);
extend("required_sem_field", required);
// Validações customizadas do Vee-Validate
require("./validators/custom-vee-validators");

Vue.filter("CNPJ", (value: any) => {
  if (value) {
    value = value.replace(/[^\d]/g, "");
    value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    return value;
  }
});

Vue.filter("CPF", (value: any) => {
  if (value) {
    value = value.replace(/[^\d]/g, "");
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
});

Vue.filter("CPF_CNPJ", (value: string) => {
  if (value) {
    value = value.replace(/[^\d]/g, "");
    if (value.length > 11) {
      value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    } else {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return value;
  }
});

Vue.filter("toFixedCurrency", (value: any) => {
  if (value) {
    let masked = new Number(value).toFixed(2);
    return masked;
  }
});


new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
